module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.f1ea7531.png";